import {
  COLOR_CHART_LEGEND_ITEMS_AND_LABELS,
  COLOR_CHART_NO_DATA,
  COLOR_CHART_TITLE,
  SENTIMENTS_EMOTIONS_CHART_PLOT_SERIES_COLOUR
} from '../colorCodes';

export const MAP_OPTIONS = {
  series: 'series',
  annotations: 'annotations',
  title: 'title',
  yAxis: 'yAxis',
  tickInterval: 'tickInterval',
  max: 'max',
  text: 'text',
};

export const DEFAULT_LEGEND_OPTIONS = {
  layout: 'horizontal',
  align: 'center',
  verticalAlign: 'top',
  y: -36,
  itemStyle: {
    color: COLOR_CHART_LEGEND_ITEMS_AND_LABELS,
    fontWeight: 'normal',
    fontSize: '10px',
    textTransform: 'capitalize',
  },
};

export const DEFAULT_PLOT_OPTIONS = {
  series: {
    marker: {
      enabled: true,
    },
    cursor: 'pointer',
  },
};

export const DEFAULT_NO_DATA_OPTIONS = {
  useHTML: true,
  style: {
    color: COLOR_CHART_NO_DATA,
    fontSize: '14px',
  },
};

export const DEFAULT_TITLE_STYLE = {
  text: '',
  align: 'left',
  style: {
    color: COLOR_CHART_TITLE,
    fontWeight: 'bold',
    fontSize: '12px',
  },
};

export const SUB_TOPIC_CLUSTERS_CHART_TITLE_STYLE = {
  text: '',
  align: 'left',
  style: {
    color: COLOR_CHART_TITLE,
    fontWeight: 'bold',
    fontSize: '14px',
  },
};

export const DEFAULT_X_AXIS_OPTIONS = {
  type: 'datetime',
  dateTimeLabelFormats: {
    day: '%e %b',
    minute: '%I:%M %P',
    hour: '%I:%M %P',
  },
  startOfWeek: 0,
  startOnTick: false,
  endOnTick: false,
  labels: {
    style: {
      color: COLOR_CHART_LEGEND_ITEMS_AND_LABELS,
      fontSize: '8px',
      lineHeight: '5px',
      textTransform: 'capitalize',
    },
  },
};

export const DEFAULT_Y_AXIS_LABELS = {
  style: {
    fontSize: '8px',
  },
  y: 2,
};

export const DEFAULT_Y_AXIS_TICK_INTERVAL = 1000;
export const DEFAULT_Y_AXIS_TITLE_STYLE   = {
  fontSize: '8px',
};

export const DEFAULT_HIGH_CHART_MAP_OPTIONS = {
  series: [],
  legend: DEFAULT_LEGEND_OPTIONS,
  plotOptions: DEFAULT_PLOT_OPTIONS,
  noData: {...DEFAULT_NO_DATA_OPTIONS},
  title: {...DEFAULT_TITLE_STYLE},
  tooltip: { enabled: true },
  credits: {
    enabled: false,
  },
  xAxis: DEFAULT_X_AXIS_OPTIONS,
  yAxis: {
    labels: DEFAULT_Y_AXIS_LABELS,
    tickInterval: DEFAULT_Y_AXIS_TICK_INTERVAL,
    title: {
      text: 'Number of Comments',
      style: DEFAULT_Y_AXIS_TITLE_STYLE,
    },
  },
};

export const PERCENTAGE_TREND_CHART_MAP_OPTIONS = {
  series: [],
  legend: DEFAULT_LEGEND_OPTIONS,
  plotOptions: DEFAULT_PLOT_OPTIONS,
  noData: {...DEFAULT_NO_DATA_OPTIONS},
  title: {...DEFAULT_TITLE_STYLE},
  tooltip: { 
    enabled: true,
    valueSuffix: ' %',
  },
  credits: {
    enabled: false,
  },
  xAxis: DEFAULT_X_AXIS_OPTIONS,
  yAxis: {
    labels: DEFAULT_Y_AXIS_LABELS,
    tickInterval: DEFAULT_Y_AXIS_TICK_INTERVAL,
    title: {
      text: 'Percentage of Comments (%)',
      style: DEFAULT_Y_AXIS_TITLE_STYLE,
    },
  },
};

export const CHART_BACKGROUND_COLOUR = 'white';
export const SENTIMENTS_EMOTIONS_CHART_MAP_OPTIONS = {
  chart: {
    type: 'column',
    backgroundColor: 'transparent',
    width: 90,
    height: 50,
  },
  series: [],
  legend: {
    enabled: false,
  },
  title: {...DEFAULT_TITLE_STYLE},
  tooltip: {
    enabled: false,
  },
  exporting: {
    enabled: false,
  },
  plotOptions: {
    series: {
      color: SENTIMENTS_EMOTIONS_CHART_PLOT_SERIES_COLOUR,
      pointWidth: 5,
      borderWidth: 1,
      borderColor: CHART_BACKGROUND_COLOUR,
    },
  },
  credits: {
    enabled: false,
  },
  xAxis: {
    visible: false,
  },
  yAxis: {
    visible: false,
  },
};

export const DEFAULT_CHART_WIDTH = 370;
export const DEFAULT_CHART_HEIGHT = 240;
export const FILTER_DATE_RANGE_FORMAT = 'YYYY-MM-DD';
export const DEFAULT_ZOOM_TYPE = 'xy';
export const DEFAULT_PAN_KEY = 'shift';

export const SERIES_KEY = 'series';
export const TITLE_KEY = 'title';
export const TEXT_KEY = 'text';


// WEBPACK FOOTER //
// ./src/features/shared-components/chart/constants/HighchartsConstants.js